import md5 from 'md5';
import AjaxUtils from '../../util/ajax_utils';
import { cleanHostName, createUUIDv4 } from '../../util/helpers';

export const ApckGoScriptScope = {
    props: {
        value: {
            // type: [Array, String],
            type: Array,
            required: true,
        },
        confirmationMessage: {
            type: String,
            default: 'Are you sure you want to delete the item',
        },
        confirmationEmptyMessage: {
            type: String,
            default: 'Are you sure you want to delete the unnamed item',
        },
        confirmationItem: {
            type: String,
            default: 'value',
        },
        topHeight: {
            type: Number,
            default: 0,
        },
        selectedValues: {
            type: Array,
            default: () => [],
        },
        // share scope validation results
        scopeResults: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            properties: [],
            isTableView: true,
            textValue: '',
            query: '',
            scopeValidationResults: [],
            isAllSelected: false,
        };
    },
    watch: {
        value(val) {
            this.loadValues(this.value);
        },
        selectedValues(val) {
            this.loadSelectedValues(val);
        },
    },
    methods: {
        updateScopeOutput() {
            this.properties.forEach((element) => {
                let canSelect = false;
                const hostItem = this.scopeValidationResults.find(
                    (item) => item.name === element.value,
                );
                // codes
                const codeClassMap = {
                    'invalid': '',
                    'unresolved': 'text-warning',
                    'not-in-scope': 'text-negative',
                };

                let iconInfo = { description: '', colorClass: '', icon: '' };
                if (hostItem) {
                    if (!hostItem.valid) {
                        iconInfo = {
                            category: hostItem.category,
                            description: hostItem.reason,
                            colorClass: codeClassMap[hostItem.code] || '',
                            icon: 'fa-exclamation-triangle',
                            isValid: hostItem.valid,
                        };
                    } else {
                        iconInfo = {
                            category: hostItem.category,
                            description: hostItem.reason,
                            colorClass: 'text-positive',
                            icon: 'fa-check',
                            isValid: hostItem.valid,
                        };
                    }

                    if (hostItem.category != 'invalid') canSelect = true;
                }

                // wildcard
                if (element.value.startsWith('*.')) {
                    canSelect = false;
                    iconInfo.icon = "fa-globe";
                    iconInfo.description = "Please enter a specific host name without including wildcards (*)."
                }

                if (!element.value) {
                    iconInfo.icon = "fa-question";
                }

                Object.assign(element, {
                    icon: iconInfo.icon,
                    description: iconInfo.description,
                    colorClass: iconInfo.colorClass,
                    canSelect,
                    selected: canSelect ? element.selected : false,
                });
            });
        },
        loadSelectedValues() {
            this.selectedValues.forEach(element => {
                const scopeItem = this.properties.find((item) => item.value === element);
                if (scopeItem) scopeItem.selected = true;
            });
        },
        loadValues(values) {
            // Filter non-existent values from the properties instead of replacing them
            // to ensure a nicer output.
            this.properties = this.properties.filter(item => values.includes(item.value));

            values.forEach((element) => {
                this.addProperty(element);
            });
            this.loadSelectedValues();
            this.validateScope();
        },
        addNewProperty() {
            this.clearQuery();
            this.addProperty('', true);
        },
        addProperty(value, isManual) {
            var new_property = {
                value: value,
                editValue: false,
                selected: false,
                icon: 'fa-question',
                description: '',
                colorClass: '',
                canSelect: false,
                isValid: false,
            };
            const scopeItem = this.properties.find((item) => item.value === value);
            if (!scopeItem || isManual) this.properties.push(new_property);
            if (isManual) this.clickEditValue(new_property);
        },
        deleteProperty(index) {
            const cmp = this;
            let message = '';
            if (cmp.properties[index].value) {
                message = cmp.confirmationMessage + ` '${cmp.properties[index].value}'?`;
            } else {
                message = cmp.confirmationEmptyMessage;
            }

            cmp.$dialog.confirm(message, `Delete ${cmp.confirmationItem}`, function () {
                cmp.properties.splice(index, 1);
                cmp.setValue();
            });
        },
        clickEditValue(item) {
            const cmp = this;
            item.editValue = true;
            this.$nextTick(() => {
                if (cmp.$refs.propertyValue) {
                    cmp.$refs.propertyValue[0].focus();
                }
            });
        },
        stopEditValue(item) {
            item.editValue = false;
            item.value = cleanHostName(item.value);
            this.setValue();
        },
        setValue() {
            const newValue = [];
            this.properties.forEach((item) => {
                if (item.value) newValue.push(item.value);
            });
            this.$emit('input', newValue);
        },
        validateScope() {
            const cmp = this;
            const scope = [];
            this.properties.forEach((item) => {
                if (item.value) scope.push(item.value);
            });
            const scopeList = scope.map(element => 'http://' + cleanHostName(element)).map(element => {
                // Manually add the `http` to the target for checking. Only the web targets are in this list but its
                // stripped as auth only really needs the domain. It must be added back for a successful scope check
                return { name: element, id: md5(element) };
            });
            AjaxUtils.ajax_post({
                url: '/validate/scope',
                data: JSON.stringify(scopeList),
                success: function (data) {
                    cmp.scopeValidationResults = data;

                    cmp.scopeValidationResults.forEach((obj) => {
                        let updateItem = scopeList.find((item) => item.id === obj.id);
                        if (updateItem) {
                            // Because we added `http://` so it would be checked as web app scope, it must be stripped
                            // again here because otherwise it affects our icons
                            obj.name = cleanHostName(updateItem.name);
                        }
                    });
                    cmp.$emit("update:scopeResults", cmp.scopeValidationResults);
                    cmp.updateScopeOutput();
                },
            });
        },
        setSelected() {
            const newValue = [];
            let isAllSelected = true;
            this.properties.forEach((item) => {
                if (item.value && item.selected) newValue.push(item.value);
                // check if we select all
                if (item.canSelect && !item.selected) isAllSelected = false;
            });
            this.$emit('update:selectedValues', newValue);
            this.isAllSelected = isAllSelected;
        },
        clearQuery() {
            this.query = '';
        },
        selectAll() {
            if (this.isAllSelected) {
                this.properties.forEach((item) => {
                    if (item.canSelect) item.selected = true;
                });
            }
            else {
                this.properties.forEach((item) => {
                    item.selected = false;
                });
            };
            this.setSelected();
        },
    },
    mounted() {
        // this.properties = [];
        this.loadValues(this.value);
    },
    computed: {
        allProperties() {
            if (!this.query) {
                return this.properties;
            }
            return this.properties.filter((item) =>
                item.value.toLowerCase().includes(this.query.toLowerCase()),
            );
        },
    },
    template: `
        <div>
        <div class="string-list">
            <div class="string-list__row string-list__row--search">
                <div class="string-list__cell">
                    <input
                        type="checkbox"
                        v-model="isAllSelected"
                        @change="selectAll"
                    >
                </div>
                <div class="string-list__cell">
                    <div class="string-list__cell__search">
                        <input
                            name="host-search"
                            v-model="query"
                            type="text"
                            placeholder="Search..."
                        />
                    </div>

                </div>
                <div class="string-list__cell">
                <a v-if="query" v-on:click="clearQuery" href="javascript:"><i class="fa fa-times-circle"></i></a>
                </div>
            </div>
            <div class="string-list__scroll">
                <div
                v-if="allProperties.length === 0 && query"
                class="string-list__row  string-list__row--search"
                >
                    <div class="string-list__cell">
                    </div>
                    <div class="string-list__cell">
                        Nothing found
                    </div>
                    <div class="string-list__cell">
                    </div>
                </div>

                <div
                    v-for="item, index in allProperties"
                    :value="index"
                    :class="['string-list__row', (item.editValue) ? 'string-list__row--highlighted' : '']"
                >
                    <div :class="['string-list__cell', (!item.canSelect) ? 'string-list____cell--disabled' : '' ]">
                        <input
                            type="checkbox"
                            v-model="item.selected"
                            @change="setSelected"
                            :disabled="!item.canSelect"
                        >
                    </div>
                    <div class="string-list__cell"
                        v-on:click="clickEditValue(item)"
                    >
                        <span
                            v-if="item.icon"
                            :class="['fa', 'string-list__cell__icon', item.icon, item.colorClass]"
                            :title="item.description"
                        ></span>
                    </div>
                    <div
                        :class="['string-list__cell', item.is_property ? 'string-list__cell--disabled' : '']"
                        v-on:click="clickEditValue(item)"
                    >
                        <span
                            v-if="!item.editValue"
                            class="string-list__cell__text"
                        >
                            {{item.value}}
                        </span>
                        <input
                            v-if="item.editValue"
                            v-model="item.value"
                            v-on:blur="stopEditValue(item)"
                            v-on:keyup.enter="stopEditValue(item)"
                            type="text"
                            ref="propertyValue"
                            autocomplete="off"
                        />
                    </div>
                    <div class="string-list__cell">
                        <a
                            class="btn"
                            href="javascript:"
                            v-on:click="deleteProperty(index)"
                            style="color:#b03630"
                        >
                            <span class="fa fa-trash"></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-group btn-property-group">
            <a
                class="btn btn-property"
                v-on:click="addNewProperty"
                href="javascript:"
            >
                <span class="fa fa-plus"></span> Add scope
            </a>
            <slot name="actionButtons"></slot>
        </div>
        </div>
        `,
};
